import React from 'react'

const Alerta = ({alerta}) => {
  return (
    <div className='alerta mb-4'>
     {alerta.msg}
    </div>
  )
}

export default Alerta